const ANDON_COLORS = {
  green : 'success',
  yellow : 'warn',
  red : 'critical',
  white : 'available'
}

export default {
  GRAPH_HEIGHT : 248,
  CAR_MINIMUM_CONFIDENCE : 0,
  LIFT_UTIL_MINIMUM_CONFIDENCE : 0,
  JACK_MINIMUM_CONFIDENCE : 0,
  LIFT_MINIMUM_CONFIDENCE : 0,
  SEVEN_DAYS_IN_MS : 1000 * 60 * 60 * 24 * 7,
  LEAD_TIME_MAX_MS : Infinity, // 60 * 40 * 1000, // 20 * 60 * 1000,
  ONE_HOUR : 1000 * 60 * 60,
  BAY_TIME_ANDON_DEFAULTS : {
    warn : 1260000, // 21 minutes
    critical : 1800000 // 30 minutes
  },
  STANDARD_WORK_CELL_PLAY_MATRIX : [
    /* eslint-disable max-len */
    [ ANDON_COLORS.green, ANDON_COLORS.green, ANDON_COLORS.green, ANDON_COLORS.green, ANDON_COLORS.green, ANDON_COLORS.green, ANDON_COLORS.green, ],
    [ ANDON_COLORS.red, ANDON_COLORS.yellow, ANDON_COLORS.green, ANDON_COLORS.green, ANDON_COLORS.green, ANDON_COLORS.green, ANDON_COLORS.green, ],
    [ ANDON_COLORS.red, ANDON_COLORS.red, ANDON_COLORS.yellow, ANDON_COLORS.green, ANDON_COLORS.green, ANDON_COLORS.green, ANDON_COLORS.green, ],
    [ ANDON_COLORS.red, ANDON_COLORS.red, ANDON_COLORS.red, ANDON_COLORS.yellow, ANDON_COLORS.green, ANDON_COLORS.green, ANDON_COLORS.green, ],
    [ ANDON_COLORS.red, ANDON_COLORS.red, ANDON_COLORS.red, ANDON_COLORS.yellow, ANDON_COLORS.green, ANDON_COLORS.green, ANDON_COLORS.green, ],
    /* eslint-enable max-len */
  ],
  BAYSIDE_WORK_CELL_PLAY_MATRIX : [
    // eslint-disable-next-line max-len
    [ ANDON_COLORS.red, ANDON_COLORS.red, ANDON_COLORS.red, ANDON_COLORS.red, ANDON_COLORS.yellow, ANDON_COLORS.green, ANDON_COLORS.green ]
  ],
  ANDON_COLORS
}
